<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'medium'">
    <div slot="title">{{getTitleText}}</div>
    <div slot="body">
      <loading
        v-if="!allProducts || blocks == null "
        class="mt10 text-center"
        :text="'Please wait'|translate"
      ></loading>
      <form v-on:submit.prevent="submitForm" v-if="allProducts && blocks != null">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">
              {{'Name'|translate}}
              <span class="required">(*)</span>
            </label>

            <input
              v-model="item.name"
              type="text"
              ref="name"
              required
              :placeholder="'Name'|translate"
              class="form-control"
            />
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">
              {{'Block'|translate}}
              <span class="required">(*)</span>
            </label>
            <select class="form-control" v-model="item.block_id" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(block) in blocks"
                :key="block.id"
                v-bind:value="block.id"
              >{{ block.name }}</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">
              {{'Start date'|translate}}
              <span class="required">(*)</span>
            </label>
            <div class="input-group">
              <date-picker v-model="item.start_date" :wrap="true" :config="config"></date-picker>
              <div class="input-group-addon pointer">
                <span class="glyphicon glyphicon-calendar"></span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">{{'Finish date'|translate}}</label>
            <div class="input-group">
              <date-picker v-model="item.finish_date" :wrap="true" :config="config"></date-picker>
              <div class="input-group-addon pointer">
                <span class="glyphicon glyphicon-calendar"></span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">
              {{'Product'|translate}}
              <span class="required">(*)</span>
            </label>
            <select class="form-control" v-model="item.product_id" required>
              <option disabled value>{{'Please select one'|translate}}</option>
              <option
                v-for="(product) in allProducts"
                :key="product.id"
                v-bind:value="product.id"
              >{{ product.name }}</option>
            </select>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12">
            <label class="mt20">{{'Seed quantity'|translate}}</label>
            <input
              v-model="item.quantity_seed"
              type="number"
              ref="quantity_seed"
              :placeholder="'Seed quantity'|translate"
              class="form-control"
            />
          </div>
        </div>

        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          {{getOKText}}
        </button>
      </form>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import Utils from "@/helpers/utils";
import datePicker from "vue-bootstrap-datetimepicker";
import Loading from "@/components/elements/Loading";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormPeriod",
  components: {
    mymodal,
    datePicker,
    Loading
  },
  props: ["pass_data", "block_id"],
  computed: {
    getTitleText() {
      if (this.item.id) {
        return this.$t("Update period");
      } else {
        return this.$t("Add period");
      }
    },
    getOKText() {
      if (this.item.id) {
        return this.$t("Update");
      } else {
        return this.$t("Add");
      }
    }
  },
  data() {
    let dateFormat = "DD/MM/YYYY";
    return {
      working: false,
      blocks: null,
      dateFormat: dateFormat,
      allProducts: null,
      config: {
        format: dateFormat,
        locale: "vi",
        maxDate: new Date()
      },
      item: {}
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    defaultValue() {
      let now = new Date();
      now.setHours(8);
      now.setMinutes(0);

      return {
        name: "",
        block_id: this.block_id,
        product_id: "",
        start_date: this.$moment(now).format(this.dateFormat),
        finish_date: null
      };
    },
    open() {
      this.$refs.theModal.open();
      if (this.pass_data) {
        this.item = JSON.parse(JSON.stringify(this.pass_data));
        this.item.start_date = this.$moment(this.item.start_date).format(
          this.dateFormat
        );
      } else {
        this.item = this.defaultValue();
      }
      console.log("open 1");
      if (!this.allProducts) {
        console.log("open 2");
        if (window.all) {
          this.allProducts = window.all;
        } else {
          Utils.getAllProducts(this, {}).then(data => {
            this.allProducts = data;
            window.all = this.allProducts;
          });
        }
      }
      if (this.blocks === null) {
        this.getBlocks();
      }

      //   for (let key in this.searchparams) {
      //     this.search_params[key] = this.searchparams[key]
      //   }
    },
    submitForm() {
      let data = JSON.parse(JSON.stringify(this.item));
      data.start_date = this.$moment(data.start_date, this.dateFormat).toDate();
      data.start_time = Math.floor(data.start_date.getTime() / 1000);
      data.finish_time = null;
      if (data.finish_date) {
        data.finish_date = this.$moment(
          data.finish_date,
          this.dateFormat
        ).toDate();
        data.finish_time = Math.floor(data.finish_date.getTime() / 1000);
      }

      let request;
      if (this.item.id) {
        request = Utils.request(this, true, "land").put(`/managePeriod/`, data);
      } else {
        request = Utils.request(this, true, "land").post(
          `/managePeriod/`,
          data
        );
      }

      request
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.$refs.theModal.close();
            this.$emit("modalData", {});
          } else {
            Utils.showError(this, this.$t(data.data));
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    getBlocks() {
      let data = {
        offset: 0,
        limit: -1
      };
      console.log("data", data);
      Utils.request(this, true, "land")
        .get(`/manageBlock/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            this.blocks = data.data.list;
            console.log("this.blocks", this.blocks);
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Cultivation/FormPeriod.vue